import {DataQueryResult} from './data-query-result.model';

export class DataQueryResultPage {

	// Static Properties
	static pageSizeOptions = [
		10,
		20,
		30,
		40,
		50,
		60,
		70,
		80,
		90,
		100,
		500,
		1000
	];

	// Properties
	pageNumber: number;
	queryResult: DataQueryResult;
}
